// removed by extract-text-webpack-plugin
module.exports = {"link":"_2Q4oAGSBKi_xcACG","active":"_2JjkK5Qk-RnmnN0u","noUnderline":"_39RYtEpBlt8o_Rkr","dotted":"_2SvxpVE7R0jHRxD7","danger":"_1H9ep2mXbORKYPcs"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Common/Link.pcss
// module id = 471
// module chunks = 1